const VAT_DIVISOR = 1.2;

/**
 * Lignes panier pour le webhook commande : id, quantité, prix (unitaire facturé + catalogue / override).
 */
export function serializeCartForOrder(cart, config) {
  const ttcKey = config.itemPriceFieldTTC;
  return cart.map((item) => {
    const f = item.toy.fields;
    const unitTTC = Number(f[ttcKey]);
    const priceTTC = Number.isFinite(unitTTC) ? unitTTC : null;
    const priceHT = priceTTC != null ? priceTTC / VAT_DIVISOR : null;
    const productName =
      f["Name"] ??
      f["Nom"] ??
      (typeof f.name === "string" ? f.name : null) ??
      null;

    return {
      id: item.toy.id,
      name: productName,
      fields: { Name: productName },
      quantity: item.quantity,
      priceTTC,
      priceHT,
      cataloguePriceTTC: f.cataloguePriceTTC ?? null,
      cataloguePriceHT: f.cataloguePriceHT ?? null,
      priceOverrideTTC: f.priceOverrideTTC ?? null,
      priceOverrideHT: f.priceOverrideHT ?? null,
    };
  });
}
